/* Swipe & Build game (mobile). See sections/dw-swipe-match.liquid. */
(() => {
  const money = (cents) =>
    '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: cents % 100 ? 2 : 0 });
  const esc = (s) =>
    String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };
  const withWidth = (src, w) => (src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '');

  async function loadProducts(root) {
    const only = (root.dataset.only || '').split(',').filter(Boolean);
    const want = new Set(only);
    const tag = root.dataset.tag || 'Glow mini';
    const all = [];
    try {
      for (let page = 1; page < 10; page++) {
        const data = await (await fetch(`/collections/all/products.json?limit=250&page=${page}`)).json();
        const list = data.products || [];
        list.forEach((p) => {
          if (want.size && !want.has(p.handle)) return;
          const v = (p.variants || []).find((x) => x.available);
          if (!v || !p.images || !p.images.length) return;
          all.push({
            id: v.id,
            handle: p.handle,
            title: p.title.replace(/^Miniature\s+/i, '').replace(/\s*Assorted.*$/i, '').replace(/\s*\(1\s*pc\)\s*$/i, ''),
            price: Math.round(parseFloat(v.price) * 100),
            compare: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
            image: withWidth(p.images[0].src, 600),
            thumb: withWidth(p.images[0].src, 160),
            url: `/products/${p.handle}`,
            tag,
          });
        });
        if (list.length < 250) break;
      }
    } catch (e) {}
    return shuffle(all);
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    const stage = root.querySelector('[data-stage]');
    const loading = root.querySelector('[data-loading]');
    const done = root.querySelector('[data-done]');
    const countEl = root.querySelector('[data-wish-count]');
    let deck = [];
    let pool = [];
    let busy = false;

    const wl = () => window.DawbuWishlist;
    const updateCount = () => (countEl.textContent = wl() ? wl().items().length : 0);
    document.addEventListener('dw:wishlist-change', updateCount);

    function cardHtml(p) {
      const sale = p.compare > p.price ? `<s>${money(p.compare)}</s>` : '';
      return `
        <div class="dw-swipe__card-img"><img src="${esc(p.image)}" alt="${esc(p.title)}" draggable="false"></div>
        <span class="dw-swipe__stamp dw-swipe__stamp--like">LOVE IT</span>
        <span class="dw-swipe__stamp dw-swipe__stamp--nope">PASS</span>
        <div class="dw-swipe__card-info">
          <span class="dw-swipe__tag">${esc(p.tag)}</span>
          <p class="dw-swipe__name">${esc(p.title)}</p>
          <p class="dw-swipe__price">${money(p.price)} ${sale}</p>
        </div>`;
    }

    function renderStack() {
      stage.querySelectorAll('.dw-swipe__card').forEach((c) => c.remove());
      done.hidden = deck.length > 0;
      deck.slice(0, 3).reverse().forEach((p, i, arr) => {
        const depth = arr.length - 1 - i; // 0 = top card
        const el = document.createElement('div');
        el.className = 'dw-swipe__card';
        el.style.setProperty('--depth', depth);
        el.innerHTML = cardHtml(p);
        if (depth === 0) bindDrag(el);
        stage.appendChild(el);
      });
      // warm the next few images
      deck.slice(3, 6).forEach((p) => (new Image().src = p.image));
    }

    function decide(liked, el) {
      if (busy || !deck.length) return;
      busy = true;
      const p = deck[0];
      const card = el || stage.querySelector('.dw-swipe__card:last-child');
      if (liked && wl()) wl().add({ id: p.id, handle: p.handle, title: p.title, price: p.price, image: p.thumb, url: p.url });
      if (card) {
        card.classList.add(liked ? 'is-liked' : 'is-noped');
        card.style.transition = 'transform .35s ease, opacity .35s ease';
        card.style.transform = `translate(${liked ? 140 : -140}%, -4%) rotate(${liked ? 22 : -22}deg)`;
        card.style.opacity = '0';
      }
      setTimeout(() => {
        deck.shift();
        renderStack();
        busy = false;
      }, card ? 300 : 0);
    }

    function bindDrag(card) {
      let x0 = 0, y0 = 0, dx = 0, dy = 0, dragging = false, horizontal = null;
      const likeStamp = card.querySelector('.dw-swipe__stamp--like');
      const nopeStamp = card.querySelector('.dw-swipe__stamp--nope');

      card.addEventListener('pointerdown', (e) => {
        if (busy) return;
        dragging = true;
        horizontal = null;
        x0 = e.clientX;
        y0 = e.clientY;
        dx = dy = 0;
        card.style.transition = 'none';
      });
      card.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        dx = e.clientX - x0;
        dy = e.clientY - y0;
        if (horizontal === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          horizontal = Math.abs(dx) > Math.abs(dy);
          if (horizontal) card.setPointerCapture(e.pointerId);
          else return (dragging = false); // let the page scroll
        }
        if (!horizontal) return;
        card.style.transform = `translate(${dx}px, ${dy * 0.15}px) rotate(${dx / 18}deg)`;
        const k = Math.min(1, Math.abs(dx) / 90);
        likeStamp.style.opacity = dx > 0 ? k : 0;
        nopeStamp.style.opacity = dx < 0 ? k : 0;
      });
      const end = () => {
        if (!dragging) return;
        dragging = false;
        if (horizontal && Math.abs(dx) > Math.min(100, card.offsetWidth * 0.28)) return decide(dx > 0, card);
        card.style.transition = 'transform .25s ease';
        card.style.transform = '';
        likeStamp.style.opacity = nopeStamp.style.opacity = 0;
      };
      card.addEventListener('pointerup', end);
      card.addEventListener('pointercancel', end);
    }

    function start() {
      const have = new Set(wl() ? wl().items().map((i) => String(i.id)) : []);
      deck = shuffle(pool.filter((p) => !have.has(String(p.id))));
      if (!deck.length) deck = shuffle(pool.slice());
      renderStack();
    }

    root.querySelector('[data-like]').addEventListener('click', () => decide(true));
    root.querySelector('[data-nope]').addEventListener('click', () => decide(false));
    root.querySelectorAll('[data-open-wishlist]').forEach((b) => b.addEventListener('click', () => wl() && wl().open()));
    root.querySelector('[data-restart]').addEventListener('click', () => {
      deck = shuffle(pool.slice());
      renderStack();
    });

    updateCount();
    loadProducts(root).then((items) => {
      pool = items;
      loading.hidden = true;
      if (!pool.length) {
        loading.hidden = false;
        loading.textContent = 'No toys to swipe right now — check back soon!';
        return;
      }
      start();
    });
  }

  function boot() {
    document.querySelectorAll('.dw-swipe').forEach((root) => {
      if (!('IntersectionObserver' in window)) return init(root);
      const io = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            io.disconnect();
            init(root);
          }
        },
        { rootMargin: '600px 0px' }
      );
      io.observe(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
